module.exports = __webpack_public_path__ + "img/notes.d4dd69a3.svg";